import eventBus from "@/eventBus"

const catch404 = () => {
  eventBus.$emit('requestErrorCaptured', 404)
}

export default catch404
